var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-container"},[_c('div',{staticClass:"dropzone"},[_vm._v(_vm._s(_vm.name))]),_c('input',{staticClass:"input",attrs:{"type":"file"}}),_c('canvas',{staticClass:"image"})])}
var staticRenderFns = []

export { render, staticRenderFns }